import "./App.css";
import { MapComponent } from "./components/MapComponent/MapComponent";

function App() {
  return (
    <div className="App">
      <MapComponent />
    </div>
  );
}

export default App;
